import * as z from "zod";

export const uncoveredSalesChannelWarningSchema = z.object({
  channelId: z.string(),
  displayName: z.string(),
  percentage: z.number(),
});

export type UncoveredSalesChannelWarning = z.infer<
  typeof uncoveredSalesChannelWarningSchema
>;
